"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _reactWindow = require("react-window");
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _ChatDotIcon = require("./ChatDotIcon");
var _ParticipantList = require("../Header/ParticipantList");
var _hooks = require("../../common/hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SelectorItem = function SelectorItem(_ref) {
  var value = _ref.value,
    active = _ref.active,
    onClick = _ref.onClick,
    unreadCount = _ref.unreadCount;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
    "data-testid": "chat_members",
    css: {
      align: "center",
      px: "$10"
    },
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "sm",
      children: value
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      css: {
        ml: "auto",
        color: "$textPrimary"
      },
      children: [unreadCount > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
        title: "".concat(unreadCount, " unread"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
          css: {
            mr: active ? "$3" : 0
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatDotIcon.ChatDotIcon, {})
        })
      }), active && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CheckIcon, {
        width: 16,
        height: 16
      })]
    })]
  });
};
var SelectorHeader = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      flexShrink: 0
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.HorizontalDivider, {
      space: 4
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "md",
      css: {
        p: "$4 $10",
        fontWeight: "$semiBold"
      },
      children: children
    })]
  });
});
var Everyone = /*#__PURE__*/_react["default"].memo(function (_ref3) {
  var onSelect = _ref3.onSelect,
    active = _ref3.active;
  var unreadCount = (0, _reactSdk.useHMSStore)(_reactSdk.selectUnreadHMSMessagesCount);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorItem, {
    value: "Everyone",
    active: active,
    unreadCount: unreadCount,
    onClick: function onClick() {
      onSelect({
        role: "",
        peerId: "",
        selection: "Everyone"
      });
    }
  });
});
var RoleItem = /*#__PURE__*/_react["default"].memo(function (_ref4) {
  var onSelect = _ref4.onSelect,
    role = _ref4.role,
    active = _ref4.active;
  var unreadCount = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectMessagesUnreadCountByRole)(role));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorItem, {
    value: role,
    active: active,
    unreadCount: unreadCount,
    onClick: function onClick() {
      onSelect({
        role: role,
        selection: role
      });
    }
  });
});
var PeerItem = function PeerItem(_ref5) {
  var onSelect = _ref5.onSelect,
    peerId = _ref5.peerId,
    name = _ref5.name,
    active = _ref5.active;
  var unreadCount = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectMessagesUnreadCountByPeerID)(peerId));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorItem, {
    value: name,
    active: active,
    unreadCount: unreadCount,
    onClick: function onClick() {
      onSelect({
        role: "",
        peerId: peerId,
        selection: name
      });
    }
  });
};
var VirtualizedSelectItemList = function VirtualizedSelectItemList(_ref6) {
  var peers = _ref6.peers,
    selectedRole = _ref6.selectedRole,
    selectedPeerId = _ref6.selectedPeerId,
    searchValue = _ref6.searchValue,
    onSelect = _ref6.onSelect;
  var _useMeasure = (0, _reactUse.useMeasure)(),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    ref = _useMeasure2[0],
    _useMeasure2$ = _useMeasure2[1],
    width = _useMeasure2$.width,
    height = _useMeasure2$.height;
  var roles = (0, _hooks.useFilteredRoles)();
  var filteredPeers = (0, _react.useMemo)(function () {
    return peers.filter(
    // search should be empty or search phrase should be included in name
    function (peer) {
      return !searchValue || peer.name.toLowerCase().includes(searchValue.toLowerCase());
    });
  }, [peers, searchValue]);
  var listItems = (0, _react.useMemo)(function () {
    var selectItems = [/*#__PURE__*/(0, _jsxRuntime.jsx)(Everyone, {
      onSelect: onSelect,
      active: !selectedRole && !selectedRole
    })];
    roles.length > 0 && selectItems.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorHeader, {
      children: "Roles"
    }));
    roles.forEach(function (userRole) {
      return selectItems.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(RoleItem, {
        active: selectedRole === userRole,
        role: userRole,
        onSelect: onSelect
      }, userRole));
    });
    filteredPeers.length > 0 && selectItems.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorHeader, {
      children: "Participants"
    }));
    filteredPeers.forEach(function (peer) {
      return selectItems.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(PeerItem, {
        name: peer.name,
        peerId: peer.id,
        active: peer.id === selectedPeerId,
        onSelect: onSelect
      }, peer.id));
    });
    return selectItems;
  }, [onSelect, selectedRole, selectedPeerId, roles, filteredPeers]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Group, {
    ref: ref,
    css: {
      height: "$64",
      overflowY: "auto"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactWindow.FixedSizeList, {
      itemSize: 52,
      itemCount: listItems.length,
      width: width,
      height: height,
      children: function children(_ref7) {
        var index = _ref7.index,
          style = _ref7.style;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: style,
          children: listItems[index]
        }, index);
      }
    })
  });
};
var ChatSelector = function ChatSelector(_ref8) {
  var role = _ref8.role,
    peerId = _ref8.peerId,
    onSelect = _ref8.onSelect;
  var peers = (0, _reactSdk.useHMSStore)(_reactSdk.selectRemotePeers);
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [peers.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        px: "$8"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ParticipantList.ParticipantSearch, {
        onSearch: setSearch,
        placeholder: "Search participants"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(VirtualizedSelectItemList, {
      selectedRole: role,
      selectedPeerId: peerId,
      onSelect: onSelect,
      peers: peers,
      searchValue: search
    })]
  });
};
exports.ChatSelector = ChatSelector;